<div class="lms-toolbar">
  <div>
    <ng-content select="[left]"></ng-content>
  </div>
  <div class="lms-toolbar__block">
    <ng-container *ngIf="options?.list?.listId">
      <lms-search-field
        *ngIf="!options.list.hideSearch"
        [listId]="options.list.listId"
        [skeletor]="options?.list?.skeletor"
        [skipEncoding]="options?.list?.skipEncoding"
      ></lms-search-field>
      <lms-items-count-selector
        *ngIf="!options.list.hideItemsSelector"
        [listId]="options.list.listId"
        class="hide-on-med-and-down"
        [skeletor]="options?.list?.skeletor"
      ></lms-items-count-selector>

      <div class="lms-toolbar__item">
        <lms-chooser-column *ngIf="options.list.columnChooser" [listId]="options.list.listId"></lms-chooser-column>
        <gl-button *ngIf="options.list.filters" icon icon-center="glicon-filter" (onClick)="iconClicked()"> </gl-button>
        <lms-filter-toggler
          *ngIf="options.list.filterRow"
          [listId]="options.list.listId"
          [skeletor]="options?.list?.skeletor"
        ></lms-filter-toggler>
        <lms-print *ngIf="!options.list.hidePrint"></lms-print>
        <lms-csv-download
          *ngIf="options.list.fields || options.list.download"
          class="hide-on-med-and-down"
          [listId]="options.list.listId"
          [fieldNames]="options.list.fields"
          [skeletor]="options?.list?.skeletor"
          [customDowload]="options?.list?.customDownload"
          (onDownload)="onDownload()"
        >
        </lms-csv-download>
      </div>
    </ng-container>
    <ng-content></ng-content>
  </div>
</div>
